import { useSelector } from 'react-redux';
import { routeParamsSelector } from '../CommonComponents/Router/Selector';

export const useRouteParams = <T>(): T => {
  return useSelector(routeParamsSelector);
};
